import { Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import {
  UspIcon,
  UspItem,
  UspWrapper,
  UspTitle,
  UspList,
  UspDetails,
} from './AccountUsps.styles';

const USP_KEYS = ['accountUsp1', 'accountUsp2', 'accountUsp3'] as const;

/**
 * The account advantages and the link from the account overlay.
 *
 * With social login on, the account button opens this overlay in place of the
 * flyout. The overlay must carry the same content. It uses the text of the
 * flyout, not a second set of keys.
 */
const AccountUsps = () => {
  const t = useTranslations('features.navigationLegacy.login.usps');

  return (
    <UspWrapper>
      <UspTitle>{t('title')}</UspTitle>
      <UspList>
        {USP_KEYS.map(key => {
          const benefit = t(key);

          // A market can leave the translation empty or set it to "null".
          return benefit && benefit !== 'null' ? (
            <UspItem key={key}>
              {/* The text beside it already says what it means. */}
              <UspIcon aria-hidden="true" />
              <span>{benefit}</span>
            </UspItem>
          ) : null;
        })}
      </UspList>
      <UspDetails>
        <Ui.TextLink
          variant="text"
          text={t('moreInfoLink.text')}
          href={t('moreInfoLink.href')}
          target="_blank"
        />
      </UspDetails>
    </UspWrapper>
  );
};

export { AccountUsps };
